import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class SearchJudgmentsService {
  constructor(
    private http: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private message: NzMessageService,
  ) {}

  searchJudgments(
    searchVal: string,
    searchField: string = 'all',
    page: number = 1,
    pageSize: number = 24,
  ): Promise<any> {
    this.ngxLoader.start();
    let url = `${SETTINGS.CMS_API}/api/judgements-and-orders?page=${page}&limit=${pageSize}`;

    if (searchVal) {
      if (searchField === 'all') {
        // Search all fields
        url += `&where[or][0][caseNo][contains]=${searchVal}`;
        url += `&where[or][1][dateOfJudgment][contains]=${searchVal}`;
        url += `&where[or][2][namesOfParties][contains]=${searchVal}`;
        url += `&where[or][3][judgmentBy][contains]=${searchVal}`;
      } else {
        // Search specific field
        switch (searchField) {
          case 'caseNo':
            url += `&where[caseNo][contains]=${searchVal}`;
            break;
          case 'dateOfJudgment':
            url += `&where[dateOfJudgment][contains]=${searchVal}`;
            break;
          case 'namesOfParties':
            url += `&where[namesOfParties][contains]=${searchVal}`;
            break;
          case 'judgmentBy':
            url += `&where[judgmentBy][contains]=${searchVal}`;
            break;
        }
      }
    }

    return new Promise((resolve, reject) => {
      return this.http.get(url).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to search judgments');
          reject(error);
        },
      );
    });
  }
}


